import React 					from 'react';
import ReactDOM 				from 'react-dom';
import BLComponent				from '../core/_BLComponent.jsx';

import InventorySetInfoSection	from './inventorySetInfoSection.jsx';


export default class InventoryComparisonTitle extends BLComponent
{
	constructor (props) 
	{
		super(props);
		this.state = {
			showModal: false
		}
	}
	render() {
		return (
			<div className="inventory-comparison__title-banner-section">
				<div className="l-center">
					<div className="inventory-comparison__grid-xl">
						<div className="inventory-comparison__grid-xl-cell-span--all l-full-width">
							<div className="l-flex l-split">
								<div className="text--uppercase inventory-comparison__text-title">inventory comparison</div> 
								<div className="l-margin-y--auto"><button className="btn inventory-comparison__btn-setting" onClick={() => this.props.func.showSettingModal()}><i className="fas fa-cog"></i><span className="inventory-comparison__text-hide-small-screen l-margin-left--sm">Settings</span></button></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}


}